import React from "react";
import "./../../UaeAttestation/UaeReq/UaeReq.css";

const TaiwanReqMain = () => {
  return (
    <div className="uaeReqMainContainer">
      <div className="uaeReqMainContent">
        <h3>Requirement of Taiwan Attestation:</h3>
        <p>
          The certificate attestation for Taiwan visa is needed for several
          causes such as student visa, work visa, residence visa, or for
          professional objectives. It is a part of the evidence that indicates
          that you are a genuine person or company. It proves that your
          documents are genuine & can be allowed in the country.
        </p>
       
      </div>
      <div className="uaeReqMainContent">
        <h3>Total time-span to get Taiwan Certificate Attestation:</h3>
        <p>
          The total time required for the certificate attestation for Taiwan for
          several reasons such as which country you need the authentication for,
          or the sort of documents, or the state you require it from. Usually,
          it will take around 2-3 Working Days to accomplish.
        </p>
      </div>
    </div>
  );
};

export default TaiwanReqMain;
